// Both pipeline generations publish first-party cards. Keep this contract shared
// by snapshots, Telegram inline results and shopping-list photo preparation.
// Only this optional v2 namespace is allowed; never accept URLs or dot segments.
const PRODUCT_IMAGE_PATH = /^\/generated\/(?:v2\/[a-z\d_-]+\/)?cards\/([a-z\d_-]+)\/([a-z\d_-]+)\.(webp|jpg)$/i;

export function isProductImagePath(
  value: unknown,
  format?: "webp" | "jpg",
): value is string {
  if (typeof value !== "string") return false;
  const match = PRODUCT_IMAGE_PATH.exec(value);
  return Boolean(match && match[0] === value && (!format || match[3]!.toLowerCase() === format));
}
